import { LINK_EXPIRATION_OPTIONS } from '../create-terms-and-condition-agreement/constants'

export {
  validate,
  hasRequiredDraftValues,
  hasRequiredSelectValues,
  mapFormToInput,
  getLinkExpirationDays,
  normalizeCustomDays
} from '../create-terms-and-condition-agreement/utils'

function getLatestVersion (versions = []) {
  if (!versions.length) return null
  return [...versions].sort((a, b) => (b.version || 0) - (a.version || 0))[0]
}

export function getLatestVersionContent (versions = []) {
  return getLatestVersion(versions)?.content || ''
}

export function isDraftAgreement (agreement) {
  const latest = getLatestVersion(agreement?.versions)
  return latest?.status === 'draft'
}

export function confirmAction (message) {
  return window.confirm(message)
}

export function mapApiToForm (agreement) {
  const days = agreement.linkExpirationDays
  const isPreset = days != null && LINK_EXPIRATION_OPTIONS[days]

  return {
    name: agreement.title || '',
    isDefault: !!agreement.isDefault,
    content: getLatestVersionContent(agreement.versions),
    warnTicketCreation: !!agreement.warnOnTicketCreation,
    warnInvoicePayment: !!agreement.warnOnInvoicePayment,
    signatureTrigger: agreement.signatureTrigger || '',
    defaultDelivery: agreement.deliveryMethod || '',
    linkExpiration: isPreset ? String(days) : (days != null ? 'CUSTOM' : ''),
    customDays: !isPreset && days != null ? String(days) : '',
    notifyAdminOnSign: agreement.notifyAdminOnSign == null
      ? ''
      : (agreement.notifyAdminOnSign ? 'YES' : 'NO')
  }
}
